// Synthesized phone ring tones via the Web Audio API — no audio asset needed.
//
// - startRingback(): outbound "calling" tone (Brazilian ringback: 425 Hz,
//   ~1s on / 4s off). Use while a call is ringing/connecting (before answer).
// - startRingtone(): inbound ring (attention double-beep), for incoming-call toasts.
// - stopRing(): stop whichever is playing.
//
// Autoplay note: an AudioContext can only start after a user gesture. Outbound
// calls begin on a click, so ringback plays. Inbound rings best-effort: if the
// page hasn't been interacted with, the browser may suspend audio until it is.

let ctx = null;
let intervalId = null;

function audioCtx() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  if (ctx.state === 'suspended') ctx.resume().catch(() => {});
  return ctx;
}

// Play one tone (one or more summed frequencies) for durationMs with a short
// attack/release so it doesn't click.
function beep(freqs, durationMs, volume = 0.15) {
  const c = audioCtx();
  if (!c) return;
  const now = c.currentTime;
  const stopAt = now + durationMs / 1000;

  const gain = c.createGain();
  gain.gain.setValueAtTime(0.0001, now);
  gain.connect(c.destination);

  freqs.forEach(f => {
    const osc = c.createOscillator();
    osc.type = 'sine';
    osc.frequency.value = f;
    osc.connect(gain);
    osc.start(now);
    osc.stop(stopAt + 0.05);
  });

  gain.gain.exponentialRampToValueAtTime(volume, now + 0.03);
  gain.gain.setValueAtTime(volume, Math.max(now + 0.03, stopAt - 0.05));
  gain.gain.exponentialRampToValueAtTime(0.0001, stopAt);
}

export function stopRing() {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
}

function loop(fn, periodMs) {
  stopRing();
  fn();
  intervalId = setInterval(fn, periodMs);
}

export function startRingback() {
  if (intervalId) return; // already ringing
  loop(() => beep([425], 1000), 5000); // 1s on, 4s off
}

export function startRingtone() {
  if (intervalId) return;
  loop(() => {
    beep([480, 620], 400);
    setTimeout(() => beep([480, 620], 400), 600);
  }, 3000);
}
